import React, {useState, useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import {scrollToRef} from "../../../../utils/common";
import {Post as PostList} from "../../../models/blog.model";
import searchClient from "../../../../plugins/algolia";
import config from "../../../../config";
import {dateFormat} from "../../../../utils/common";
import {
  InstantSearch,
  Hits,
  SearchBox,
  Pagination,
  Highlight,
  Configure,
} from 'react-instantsearch-dom';

type SelectedItem = {
  selected: number;
};

interface BlogPostsProps {
  catId: number | string;
}

function Post({hit}: { hit: any }) {
  let postUrl = `${config.WEB_URL_ROOT}blog/post/${hit.post_slug}`
  return (
    <React.Fragment>
      {/* <pre>{JSON.stringify(hit, null, 2)}</pre> */}
      <div className="blog-post row">
        <div className="col-md-3">
          <div className="img-date">
            <div className="img-blog">
              <a href={postUrl}>
                <img className="img-responsive w-100" src={hit.post_image} alt="" />
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-9">
          <h3>
            <a href={postUrl}>
              <Highlight attribute="post_title" hit={hit} />
            </a>
          </h3>
          <div className="post-info">
            <p><i className="fa fa-clock-o"></i>Posted on {dateFormat(hit.post_date)}</p>
            <p><i className="fa fa-user"></i>by <a href="#">{hit.user.name}</a></p>
            <p><i className="fa fa-comment"></i><a href="#">pending - 12 Comments</a></p>
          </div>

          <p><Highlight attribute="post_content" hit={hit} /></p>

        </div>
      </div>


    </React.Fragment>
  );
}

const BlogPosts: React.FC<BlogPostsProps> = (props) => {

  const catId = props.catId;
  const [postsList, setPostsList] = useState<PostList[]>([]);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [currPage, setCurrPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [error, setError] = useState<string>('');

  const mainDiv = useRef<HTMLDivElement>(null);


  const fetchPosts = async () => {
    setIsLoading(true);
    setError('');
    try {
      let url = `blog/posts`;
      url += `?page=${currPage}`;

      if (catId) {
        url += `&category_id=${catId}`
      }

      const {data} = await axios.get(url);
      setPostsList(data.data);
      setCurrPage(data.meta.current_page);
      setTotalPages(data.meta.last_page);
      scrollToRef(mainDiv);
    } catch (error: any) {
      setError(error.message);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    // fetchPosts();
  }, [currPage]);

  const handlePageClick = (selectedItem: SelectedItem) => {
    const pageNum = selectedItem.selected + 1;
    setCurrPage(pageNum);
  }

  return (
    <div ref={mainDiv}>
      <InstantSearch indexName="dev_pets_BLOG" searchClient={searchClient}>
        <Configure
          hitsPerPage={4}
        />
        <SearchBox />
        <div className="py-3"></div>
        <Hits<Hits> hitComponent={Post} />
        <Pagination />
      </InstantSearch>

    </div>
  );
}

export default BlogPosts;

/*if (document.getElementById('blog-container')) {
    const element = document.getElementById('blog-container') as HTMLElement
    const catId:string = element.dataset.categoryId!;
    ReactDOM.render(<BlogPosts catId={catId}/>, document.getElementById('blog-container'));
}*/
